// src/hooks/useLogin.ts
import { useMutation } from '@tanstack/react-query';
import { LOGIN } from '../../constants/apiEndpoints';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../redux/hooks';
import { setAuthData } from '../../redux/slices/authSlice';
import { UserRole } from '../../redux/types';
import { handleErrorResponse } from '../../utils/handleError';
import apiClient from '../../lib/apiClient';

const loginUser = async (credentials: { email: string; password: string }) => {
  const { data } = await apiClient.post(LOGIN, { user: credentials });
  return data;
};

export function useLogin() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [disableSubmit, setDisableSubmit] = useState(false);

  const { mutate, isPending } = useMutation({
    mutationKey: ['patient-login'],
    mutationFn: loginUser,
    onSuccess: (data) => {
      const token = data.data.token;
      const patientData = data.data.patient;

      const authData = {
        accessToken: token,
        currentUser: {
          id: patientData?.id,
          firstName: patientData?.first_name,
          lastName: patientData?.last_name,
          fullName: patientData?.full_name,
          hospitalId: patientData?.hospital_id,
          email: patientData?.email,
          mobileNumber: patientData?.mobile_number,
          role: UserRole?.Patient,
          profilePictureUrl: null,
          timezone: null,
          patientPlatformFirstLogin: patientData?.patient_platform_first_login,
          ...patientData,
        },
      };

      dispatch(setAuthData(authData));
      localStorage.setItem('AUTH_USER_DATA', JSON.stringify(authData));

      // const message = data?.message;
      // if (message)
      //   triggerSnackbar({
      //     message: data?.message,
      //     severity: 'success',
      //   });
      navigate('/dashboard');
    },
    onError: (error) => handleErrorResponse(error, 'Login'),
    onSettled: () => setDisableSubmit(false),
  });

  const sendSignInRequest = (credentials: {
    email: string;
    password: string;
  }) => {
    setDisableSubmit(true);
    mutate(credentials);
  };

  return {
    sendSignInRequest,
    disableSubmit: isPending || disableSubmit,
    isPending,
  };
}
